import { Store, Action, Dispatch } from 'redux';
import { onBadgesChanged } from './actions';
import _ from 'lodash';

export const badgesMiddleware = (store: Store) => {
  let previosBadges: any[] | null = null;

  return (next: Dispatch<Action>) => {
    return (action: Action) => {
      const returnValue = next(action);

      const userProfileState = store.getState().userProfile;

      const nextBadges = userProfileState.badges;

      const badgesUpdated = !_.isEqual(previosBadges, nextBadges);

      previosBadges = nextBadges;

      if (previosBadges && badgesUpdated) {
        store.dispatch(onBadgesChanged());
      }

      return returnValue;
    };
  };
};



// WEBPACK FOOTER //
// ./src/containers/Badges/middleware.ts